import { z } from 'zod';

export const cancelOrderSchema = z.object({
  reason: z
    .string()
    .trim()
    .min(1, { error: 'orders:cancel.validation.reasonRequired' })
    .max(500, { error: 'orders:cancel.validation.reasonLength' }),
  restock: z.boolean(),
  refund: z.boolean(),
});

export type CancelOrderFormInput = z.input<typeof cancelOrderSchema>;
export type CancelOrderFormOutput = z.output<typeof cancelOrderSchema>;
